import { render, staticRenderFns } from "./deanEmail.vue?vue&type=template&id=b2ffa1ac&scoped=true"
import script from "./deanEmail.vue?vue&type=script&lang=js"
export * from "./deanEmail.vue?vue&type=script&lang=js"
import style0 from "./deanEmail.vue?vue&type=style&index=0&id=b2ffa1ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ffa1ac",
  null
  
)

export default component.exports